<template>
    <div class="layout-padding">
        <div class="row gutter-sm">
            <div v-if="webcast.webcast_type === 1" class="col-xs-12" :class="webcast.use_chat ? 'col-sm-8' : 'col-sm-12'">
                <webcast-youtube :source="youtubeParser(webcast.embed)" />
            </div>

            <div v-if="webcast.webcast_type === 2 && !load_wowza_player && !webcast.transmission_downloaded && (live && !live.st)" class="col-xs-12" :class="webcast.use_chat ? 'col-sm-8' : 'col-sm-12'">
                <!-- <img class="webcast-poster" :src="webcast.webcast_images[4].image" alt="webcast poster"> -->
                <div class="webcast-poster">
                    <p>{{ this.$t('webcast_not_started') }}</p>
                </div>
            </div>

            <div v-if="webcast.webcast_type === 2 && load_wowza_player && !webcast.transmission_downloaded && (live && live.st)" class="col-xs-12" :class="webcast.use_chat ? 'col-sm-8' : 'col-sm-12'">
                <webcast-wowza :source="webcast" :refresh="true"/>
            </div>

            <div v-if="webcast.webcast_type === 2 && webcast.transmission_downloaded" class="col-xs-12" :class="webcast.use_chat ? 'col-sm-8' : 'col-sm-12'">
                <video-plyr :file_url="webcast.embed" :id="webcast.id"/>
            </div>

            <div v-if="webcast.webcast_type === 3" class="col-xs-12" :class="webcast.use_chat ? 'col-sm-8' : 'col-sm-12'">
                <webcast-vimeo :source="webcast.embed"/>
            </div>

            <div class="col-xs-12 col-sm-4" v-if="webcast.use_chat" :style="$q.platform.is.mobile ? '' : `height: ${video_height}px;`">
                <chat :id_webcast="webcast.id" type_chat="public" order="t" v-if="webcast.id" :from_home="true" />
            </div>

            <div class="col-xs-12 col-sm-12" v-if="webcast.use_chat">
                <q-field :helper="webcast.chat_moderated ? $t('all_questions_will_be_moderated_before_showing_on_chat') : ''">
                    <q-input v-model="new_message" :float-label="$t('new_message')" @keydown.enter="sendMessage()" :disable="webcast.status === 4" />
                </q-field>
            </div>
        </div>

        <div class="row gutter-sm justify-end q-mt-md" v-if="webcast.use_chat">
            <div class="col-xs-12 col-sm-3">
                <q-btn color="secondary" class="full-width" :label="$t('send')" icon="far fa-comment-dots" @click="sendMessage()" :disable="webcast.status === 4" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import WebcastYoutube from 'components/players/WebcastYoutube'
import Video from 'components/players/Video'
import WebcastVimeo from 'components/players/WebcastVimeo'
import Chat from 'components/webcasts/Chat'

export default {
    props: ['webcast', 'live'],

    data() {
        return {
            new_message: '',
            height: '',
            load_wowza_player: false,
            loading: false,
            playlist_check_interval: null
        }
    },

    components: {
        'webcast-youtube': WebcastYoutube,
        'webcast-wowza': () => import('components/players/WebcastWowza'),
        'webcast-vimeo': WebcastVimeo,
        'video-plyr': Video,
        'chat': Chat
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            video_height: 'webcasts/video_height'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        }
    },

    methods: {
        sendMessage() {
            if (this.new_message) {
                let message = this.new_message
                this.new_message = ''

                let fd = new FormData()
                fd.append('message', message)

                this.$axios.post(`/etraining_webcasts/webcasts/${this.webcast.id}/send_chat_message/`, fd, this.getHeader)
                .then(response => {
                    this.$q.notify({
                        message: this.webcast.chat_moderated ? this.$t('your_message_was_received_and_is_awating_moderation') : this.$t('your_message_was_received'),
                        type: 'positive',
                        icon: 'fal fa-save'
                    })
                })
                .catch(e => {
                    console.log(e)
                })
            }
        },

        youtubeParser(url) {
            if (url) {
                let regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/
                let match = url.match(regExp)
                return (match && match[7].length == 11)? match[7] : ''
            }
            else return ''
        },

        getPlaylist() {
            this.$axios.get(this.webcast.webcast_player_hls_playback_url)
            .then(response => {
                if (response.status === 200) {
                    this.playListReady()
                }
            })
            .catch(e => {
                return
            })
        },

        checkPlaylistState() {
			this.playlist_check_interval = setInterval(this.getPlaylist, 1500)
        },

        playListReady() {
            clearInterval(this.playlist_check_interval)
            this.loading = false
            this.load_wowza_player = true
            this.$q.loading.hide()
        },
    },

    mounted () {
        if (this.live) {
            if(this.live.st) {
                this.$q.loading.show({
				    message: this.$t('wait_stream_will_start')
                })
                this.loading = true
                this.checkPlaylistState()
            }
        }
    },

    watch: {
        live: function() {
            if(this.live.st) {
                this.$q.loading.show({
				    message: this.$t('wait_stream_will_start')
                })
                this.loading = true
                this.checkPlaylistState()
            }
        },
        deep: true
    }
}
</script>

<style lang="stylus" scoped>
.card-players
    height 600px
    text-align center

.webcast-poster
    display flex
    min-height 25vh
    border-radius 10px
    background #242424
    color white
    justify-content center
    align-items center
</style>
